import React, {useMemo, useRef} from "react";
import {BufferGeometry} from "three";

export type LineProps = {
    startLine: readonly [number, number, number];
    endLine: readonly [number, number, number];
    color: string;
};

export const Line = (props: JSX.IntrinsicElements['line'] & LineProps) => {

    const geoRef = useRef<BufferGeometry>();
    const {startLine: [x1, y1, z1], endLine: [x2, y2, z2], color = "black"} = props;

    const vertices = useMemo(() => {
        if (geoRef.current) {
            // Required for updating geometry vertex position
            geoRef.current.attributes.position.needsUpdate = true;
        }
        return new Float32Array([
            x1, y1, z1,
            x2, y2, z2,
        ]);
    }, [x1, y1, z1, x2, y2, z2]);

    return (
        <line>
            <bufferGeometry ref={geoRef} attach="geometry">
                <bufferAttribute
                    attachObject={["attributes", "position"]}
                    count={vertices.length / 3}
                    array={vertices}
                    itemSize={3}
                />
            </bufferGeometry>
            <lineBasicMaterial color={color} linewidth={5} />
        </line>
    );
};